import React from 'react';
import type { Testimonial } from '../data/content';
type TestimonialCardProps = {
  testimonial: Testimonial;
  layout?: 'quoteFirst' | 'nameFirst';
};
export function TestimonialCard({
  testimonial,
  layout = 'quoteFirst'
}: TestimonialCardProps) {
  const header = <div className="flex items-center gap-3" data-id="element-254" data-mp="2kf55yf11scq8">
      <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-navy font-display text-sm font-extrabold text-gold" aria-hidden="true" data-id="element-255" data-mp="2p8q88j9obsv8">
        {testimonial.initials}
      </span>
      <div data-id="element-256" data-mp="2z41eseaxhtrw">
        <p className="font-display text-base font-bold text-navy" data-id="element-257" data-mp="2z7ywqwlrsfa7">{testimonial.name}</p>
        <p className="text-xs font-semibold text-navy/60" data-id="element-258" data-mp="345qnvoelbxdc">{testimonial.meta}</p>
      </div>
      <span className="ml-auto text-sm text-gold" aria-label="5 de 5 estrellas" data-id="element-259" data-mp="3860y5d9f19y0">
        ⭐⭐⭐⭐⭐
      </span>
    </div>;
  return <figure className="flex h-full flex-col gap-4 rounded-2xl border border-navy/10 bg-white p-5 shadow-card" data-id="element-260" data-mp="1dsjh893inbby">
      {layout === 'nameFirst' && header}
      <blockquote className="text-sm leading-relaxed text-navy/85 sm:text-base" data-id="element-261" data-mp="htmdptmntv2p">
        “{testimonial.quote}”
      </blockquote>
      {layout === 'quoteFirst' && <figcaption className="mt-auto" data-id="element-262" data-mp="82roqhi14hdk">{header}</figcaption>}
    </figure>;
}